export default __webpack_public_path__ + "static/media/house_disc.d4ab19b2.png";